<template>
  <div>
    <NavBar />
    <div class="container">
      <div class="row">
        <div class="col">
          <h1>Edit Organization</h1>
        </div>
      </div>
      <div class="row">
        <div class="col-xs col-lg-3">
          <ul class="nav nav-pills flex-column">
            <li class="nav-item" v-for="link in links" :key="link.href">
              <router-link :to="link.href" v-slot="{ href, isActive, navigate }">
                <a class="nav-link" :class="isActive ? 'active' : ''" :href="href" @click="navigate">{{ link.text }}</a>
              </router-link>
            </li>
          </ul>
        </div>
        <div class="col-xs col-lg-9">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import NavBar from "@/views/reports/NavBar.vue";

export default {
  components: {
    NavBar,
  },
  props: {
    organizationId: String,
  },
  computed: {
    ...mapGetters("role", ["isVerensicsAdministrator"]),
    ...mapGetters("feature", ["hasReports", "hasInvestigations"]),
    links() {
      var links = [
        { text: "Profile", href: `/organizations/${this.organizationId}/profile` },
        { text: "Regions", href: `/organizations/${this.organizationId}/regions` },
        { text: "Facilities/Stores", href: `/organizations/${this.organizationId}/facilities` },
        { text: "Functions/Districts", href: `/organizations/${this.organizationId}/functions` },
        { text: "Companies/Divisions", href: `/organizations/${this.organizationId}/companies` },
        { text: "Internationalization", href: `/organizations/${this.organizationId}/internationalization` },
      ];

      if (this.hasInvestigations) {
        links.push({ text: "Interviews", href: `/organizations/${this.organizationId}/interviews` });
      }

      if (this.isVerensicsAdministrator) {
        links.push({ text: "Features", href: `/organizations/${this.organizationId}/features` });
        links.push({ text: "Tests", href: `/organizations/${this.organizationId}/tests` });
        links.push({ text: "Question Exclusions", href: `/organizations/${this.organizationId}/questionexclusions` });
      }

      return links;
    },
  },
};
</script>
